<template>
	<div class="logon">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.1rem" @click="back" />
			<div>手机快速注册</div>
			<div></div>
		</div>
		<!--logo -->
		<!-- <div class="image"> -->
		<!-- <img src="../../assets/_logon.jpg" alt=""> -->
		<!-- </div> -->
		<!--注册框 -->
		<div class="action">
			<van-cell-group>
				<van-field v-model="usertel" clearable placeholder="请输入手机号" label="手机号" />
				<van-field v-model="sms" clearable placeholder="手机验证码" label="验证码">
					<van-button slot="button" size="small" type="primary" :disabled="code" @click="getcode">{{buttonMsg}}</van-button>
				</van-field>
				<van-field v-model="password" clearable type="password" placeholder="6-12位字母数字" label="设置密码" />
			</van-cell-group>
			<div class="agree">
				<input type="checkbox" class="check_box tui-checkbox" v-model="checked">
				注册即代表您同意<router-link to="_treaty?id=1">《俱百家用户服务协议》</router-link>
			</div>
			<div class="btn">
				<button :disabled="!checked" :class="{disabled:!checked}" @click="msg">注册</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				usertel: '',
				password: '',
				sms: '',
				code: false,
				checked: true,
				buttonMsg: '获取验证码',
				iphon: '',
				codes: ''
			}
		},
		created() {
			
		},
		methods: {
			msg() {
				if (this.usertel == '') {
					this.$toast('请输入手机号');
					return false;
				}
				if (this.sms == '') {
					this.$toast('请输入验证码');
					return false;
				}
				if (this.usertel != this.iphon || this.sms != this.codes) {
					this.$toast('验证码错误');
					return false;
				}
				if (this.password == '') {
					this.$toast('密码不能为空');
					return false;
				}
				if (this.password.length < 6 || this.password.length > 12) {
					this.$toast('密码只能为6-12位');
					return false;
				}
				var obj = {
					tel: this.usertel,
					password: this.password,
					user_type: 'h5'
				}
				if (localStorage.getItem('user_id') != null && localStorage.getItem('user_id') != '') {
					obj.share_id = localStorage.getItem('user_id')
				}
				this.$axios.post(baseUrl + '/mobile/User/register', obj).then((res) => {
					if (res.data.code == 1007) {
						localStorage.setItem('Authorization', res.data.data);
						this.$toast(res.data.msg);
						setTimeout(() => {
							this.$router.push({
								path: '/Home'
							})
						}, 1000)
					}
					this.$toast(res.data.msg);
				}).catch((err) => {
					console.log(err);
				});
			},
			//获取验证码
			getcode() {
				if (this.usertel === '') {
					this.$toast('请填写手机号');
					return false;
				} else if (this.usertel && (!(/^[1][345789]\d{9}$/).test(this.usertel) || !(/^[1-9]\d*$/).test(this.usertel) ||
						this.usertel.length !== 11)) {
					this.$toast('手机号码不符合规范');
					return false;
				} else {
					this.code = false
				}
				this.$axios.post(baseUrl + '/mobile/User/get_register_code', {
					tel: this.usertel
				}).then((res) => {
					if (res.data.code == 2001) {
						this.$toast(res.data.msg);
						this.iphon = res.data.data.tel;
						this.codes = res.data.data.code;
						this.buttonMsg = 60;
						this.code = true
						var auth_timer = setInterval(() => {
							this.buttonMsg--;
							if (this.buttonMsg <= 0) {
								this.buttonMsg = '获取验证码'
								this.code = false
								clearInterval(auth_timer)
							}
						}, 1000)
					} else {
						this.$toast(res.data.msg);
					}
				}).catch((err) => {
					console.log(err);
				});
			}
		}
	}
</script>

<style scoped>
	@import "logon.css";
</style>



// WEBPACK FOOTER //
// src/components/logon/logon.vue